import { render, staticRenderFns } from "./PerformanceSetting.vue?vue&type=template&id=063ea5ce&scoped=true"
import script from "./PerformanceSetting.vue?vue&type=script&lang=js"
export * from "./PerformanceSetting.vue?vue&type=script&lang=js"
import style0 from "./PerformanceSetting.vue?vue&type=style&index=0&id=063ea5ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063ea5ce",
  null
  
)

export default component.exports